import { Link } from "react-router-dom";
import { videos } from "@/mocks/videos";
import { formatViews } from "@/utils/format";

export default function HotRanking() {
  const top = [...videos].sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <aside className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-5 h-fit">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-600">
          <i className="ri-fire-line text-lg" aria-hidden="true"></i>
        </span>
        <h2 className="font-heading font-bold text-lg text-foreground-950">热门榜单</h2>
      </div>
      <ol className="space-y-1">
        {top.map((v, i) => (
          <li key={v.id}>
            <Link
              to={`/video/${v.id}`}
              className="flex items-center gap-3 p-2 rounded-md hover:bg-background-100 transition-colors"
            >
              <span
                className={`w-6 text-center font-heading font-extrabold text-sm ${
                  i < 3 ? "text-primary-500" : "text-foreground-300"
                }`}
              >
                {i + 1}
              </span>
              <div className="relative w-16 h-10 rounded overflow-hidden bg-background-200 shrink-0">
                <img
                  src={v.cover}
                  alt={v.title}
                  title={`${v.title} - 呱呱视频社区`}
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm text-foreground-800 line-clamp-1">{v.title}</p>
                <p className="mt-0.5 text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-play-circle-line" aria-hidden="true"></i>
                  {formatViews(v.views)} 次播放
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ol>
      <Link
        to="/category/short"
        className="mt-4 flex items-center justify-center gap-1 h-10 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors"
      >
        查看全部热门
        <i className="ri-arrow-right-line" aria-hidden="true"></i>
      </Link>
    </aside>
  );
}